import { render } from "./MemberTierForm.vue?vue&type=template&id=55eba780&scoped=true"
import script from "./MemberTierForm.vue?vue&type=script&lang=js"
export * from "./MemberTierForm.vue?vue&type=script&lang=js"

import "./MemberTierForm.vue?vue&type=style&index=0&id=55eba780&scoped=true&lang=css"

import exportComponent from "/home/forge/mymembership.id/releases/81403580/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55eba780"]])

export default __exports__